import {
    BULK_ITEMS_ADD,
    BULK_ITEMS_CLEAR,
    BULK_ITEMS_DESELECT_ALL,
    BULK_ITEMS_REMOVE,
    BULK_ITEMS_SELECT_ALL,
    BULK_ITEMS_SELECT,
} from "constants/action-types";

// can be either entry or item
export const addToSelectedItems = (id) => {
    return {
        type: BULK_ITEMS_ADD,
        payload: id,
    };
};

export const removeFromSelectedItems = (id) => {
    return {
        type: BULK_ITEMS_REMOVE,
        payload: id,
    };
};

export const selectedItems = (ids: string[]) => {
    return {
        type: BULK_ITEMS_SELECT,
        payload: ids,
    };
};

export const clearAllSelectedItems = () => {
    return {
        type: BULK_ITEMS_CLEAR,
    };
};

export const selectedAllItems = () => {
    return {
        type: BULK_ITEMS_SELECT_ALL,
    };
};

export const deselectedAllItems = () => {
    return {
        type: BULK_ITEMS_DESELECT_ALL,
    };
};
